import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-badminton-competition',
  templateUrl: './badminton-competition.component.html',
  styleUrls: ['./badminton-competition.component.scss']
})
export class BadmintonCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  

}
